import styled from 'styled-components';

export const Table = styled.table`
  thead {
    th {
      border-top: 1px solid ${({ theme }) => theme.colors.quoteBgc} !important;
      border-bottom: 1px solid ${({ theme }) => theme.colors.quoteBgc} !important;
    }
    .ant-table-cell-scrollbar {
      border: none !important;
      background-color: transparent !important;
    }

    tr:not(:first-child) {
      th {
        border-top: none !important;
        border-bottom: 1px solid ${({ theme }) => theme.colors.quoteBgc} !important;
      }
    }
    tr:first-child > *:first-child {
      border-radius: 0px !important;
    }
  }
  tbody {
    .ant-table-selection-column {
      border-bottom: 1px solid ${({ theme }) => theme.colors.quoteBgc} !important;
    }
    // tr:first-child {
    //   td {
    //     border-top: 1px solid ${({ theme }) => theme.colors.quoteBgc} !important;
    //     padding: 0 !important;
    //   }
    // }

    // td {
    //   border-bottom: 1px solid ${({ theme }) => theme.colors.quoteBgc} !important;
    // }

    // tr:last-child {
    //   td {
    //     border-bottom: 1px solid ${({ theme }) => theme.colors.quoteBgc} !important;
    //   }
    // }
  }
`;
